<template>
    <div>
        <my-header :breadcrumb="breadcrumb"></my-header>
        <el-card class="box-card">
            <!--搜索-->
            <el-button type="primary" @click="dialogFormVisible=true">添加</el-button>
            <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="菜单名称" :label-width="formLabelWidth">
                        <el-input v-model="form.menu_name"></el-input>
                    </el-form-item>

                    <el-form-item label="链接地址" :label-width="formLabelWidth">
                        <el-input v-model="form.menu_url" placeholder="请输入链接地址"></el-input>
                    </el-form-item>
                    <el-form-item label="上级菜单" :label-width="formLabelWidth">
                        <el-select v-model="form.parent_id" placeholder="请选择上级菜单">
                            <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.menu_name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序" :label-width="formLabelWidth">
                        <el-input v-model="form.order_sort"></el-input>
                    </el-form-item>
                    <el-form-item label="是否显示" :label-width="formLabelWidth">
                        <el-switch
                                v-model="form.status"
                                :active-value="1"
                                :inactive-value="0" @change="changeStatus"
                        >
                        </el-switch>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="clickAdd">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 工具栏（列表名称、列表显示项设置） -->
            <!--列表内容-->
            <el-table
                    :data="tableData"
                    style="width: 100%;margin:20px 0 0 0;"
                    row-key="id"
                    :default-sort="{prop: 'order_sort', order: 'ascending'}"
                    default-expand-all
                     :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >

                <el-table-column
                        prop="menu_name"
                        label="菜单名称"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="order_sort"
                        label="排序"
                        sortable
                >
                </el-table-column>

                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                        <el-button
                                size="mini"
                                type="success"
                                @click="handlePermission(scope.$index, scope.row)">权限列表
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount" :page-size="10" class="pages"   @current-change="handleCurrentChange">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    import MyHeader from "../header";
    export default {
        name: "menu-admin",
        components: {MyHeader},
        data(){
            return {
                breadcrumb: [
                    {name: '菜单管理'},
                    {name: '菜单列表'}
                ],
                activeTab:'1',
                tableData:[],
                formInline:{},
                totalCount:0,
                dialogFormVisible:false,
                form:{
                  status:1
                },
                formLabelWidth: '120px',
                dialogTitle:'添加菜单',
                options:[]
            }
        },
        created() {
            this.getList();
            this.$http.get('/v1/menu/get-submenu',{params:{parentId:61}}).then(({data}) => {
                this.options = data;
            })
        },
        methods:{
            getList(page){
                if (!page) {
                    page = 1;
                }
                this.$http.get('/v1/menu/list',{params:{page:page,parentId:61}}).then(({data})=>{
                    for(let i in data){
                        data[i].order_sort = parseInt(data[i].order_sort)
                    }
                    this.tableData = data;
                    //this.totalCount = parseInt(data.result.totalCount);
                })
            },
            handleEdit(index,row){
                this.dialogTitle = '修改菜单';
                this.$http.get('/v1/menu/view',{params:{id:row.id}}).then(({data})=>{
                    this.form = data.result;
                })
                this.dialogFormVisible = true;
            },
            handleDelete(index,row){
                this.$http.delete('/v1/menu/delete',{params:{id:row.id}}).then(({data}) => {
                    if (data.errcode == 0) {
                        this.$message.success(data.msg)
                        this.getList();
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            },
            clickAdd(){
                if (!this.form.id){
                  if (!this.form.parent_id){
                    this.form.parent_id = 61;
                  }
                    this.$http.post('/v1/menu/create',this.form).then(({data})=>{
                        if (data.errcode == 0) {
                            this.$message.success(data.msg)
                            this.dialogFormVisible = false;
                            this.getList()
                        }else {
                            this.$message.error(data.msg)
                        }
                    })
                }else {
                    this.$http.patch('/v1/menu/update',this.form).then(({data})=>{
                        if (data.errcode == 0) {
                            this.$message.success(data.msg)
                            this.dialogFormVisible = false;
                            this.getList()
                        }else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            },
            handleCurrentChange(page){
                this.getList(page)
            },
            handlePermission(index,row){
                this.$router.push('/admin/setting/menu-permission?menuId='+row.id)
            },
          changeStatus(val){
              this.form.status = val
          }
        }
    }
</script>

<style scoped>
    .box-card{
        margin:20px;
    }
    .pages{
        text-align: right;
        margin: 20px 0 0 0;
    }
    .goods-image, .goods-image img {
        float: left;
    }
    .goods-name {
        display: inline-block;
        margin: 0 0 0 10px;
        width:290px;
    }
</style>
